import getPartnerBrandedFooter from 'yola-editor/src/js/modules/user/selectors/partner-branded-footer';

const isBrandedFooterFeatureEnabled = (state) => Boolean(getPartnerBrandedFooter(state));
export default isBrandedFooterFeatureEnabled;
